



































import Vue from 'vue';
import CompanyList from '~/shared/CompanyList.vue';
import PostingModule from '~/shared/postingmodule/PostingModule.vue';
import WebinarList from './components/WebinarList.vue';
import CompanyService from '~/services/CompanyService';
import { SHOW_CHAT_IN_COMPANY_LIST } from '~/router';
import { VFairOrganization, VFairType, VFairWebinar } from '~/services/VFairService';
import URLS from '~/URLS';

export default Vue.extend({
    name: 'Booths',
    components: {
        CompanyList,
        PostingModule,
        WebinarList,
    },
    props: {
        vFairType: {
            type: Number,
            default: VFairType.Standard,
        },
    },
    data() {
        return {
            companies: [] as VFairOrganization[],
            companiesLoading: true,
            events: [] as VFairWebinar[],
        };
    },
    computed: {
        interfaces(): any {
            return (this as any).$interfaces;
        },
        URLS(): typeof URLS {
            return (this as any).$URLS;
        },

        isSchoolAdmission(): boolean {
            return this.vFairType == VFairType.SchoolAdmission;
        },
        companiesHeader(): string {
            return this.isSchoolAdmission
                ? this.$t('vfair.pavilionTabs.degreesPrograms').toString()
                : this.$t('vfair.pavilionTabs.booths').toString();
        },
        chatUserSummary(): any {
            return SHOW_CHAT_IN_COMPANY_LIST
                ? this.interfaces.communication.chat.availability.summary.get({
                      reactive: true,
                  })
                : [];
        },
        featuredCompanies(): { id: number; logo: string; name: string }[] {
            return this.companies.map(org => {
                return {
                    id: org.organizationId,
                    logo: org.logo,
                    name: org.title,
                    prioritized: org.prioritized,
                };
            });
        },
        jobs(): any[] {
            const jobs = this.interfaces.posting.get({
                reactive: true,
                vfair_id: this.$route.params.id,
                mode: 'featured',
            }).data as any[];

            if (!this.$route.query.pavilion_id) return jobs;
            if (this.companiesLoading || !this.companies.length) return [];

            const companyIds = this.companies.map(company => company.organizationId);
            return jobs.filter(job => companyIds.includes(parseInt(job.companyId, 10)));
        },
        webinars(): VFairWebinar[] {
            return this.filterEventsByHasDuration(this.events, true);
        },
    },
    methods: {
        filterEventsByHasDuration(events: VFairWebinar[], hasDuration: boolean) {
            return events.filter(event => {
                return hasDuration === !!(event.startTime && event.endTime);
            });
        },
        async fetchEvents(): Promise<void> {
            if (this.$route.params.id) {
                let events = await this.interfaces.vfair.id(this.$route.params.id).events.get({
                    reactive: false,
                });

                events = events.data as VFairWebinar[];

                if (!this.$route.query.pavilion_id) {
                    this.events = events;
                    return;
                }

                const companyIds = this.companies.map(company => company.organizationId);

                this.events = events.filter((event: VFairWebinar) =>
                    companyIds.includes(event.ownerOrganizationId)
                );
            }
        },
        async fetchCompaniesData() {
            if (this.$route.params.id) {
                const pavilionId = this.$route.query.pavilion_id;
                const result = await CompanyService.getVFairCompanies(
                    this.$route.params.id,
                    typeof pavilionId === 'string' ? pavilionId : undefined
                );

                this.companiesLoading = false;
                this.companies = result.data.filter(c => c.status === 2);
            } else {
                return { loading: true };
            }
        },
        chatUserSummaryData(): { count: number; id: string; organizationId: string }[] {
            return this.chatUserSummary.data;
        },
        chatUserSummaryLoading(): boolean {
            return this.chatUserSummary.loading;
        },
        resolveBoothRoute(id: string): string {
            let base = this.URLS.vfair.concat('/', this.$route.params.id).concat('/booths/', id);
            this.$route.query.pavilion_id &&
                (base += `?pavilion_id=${this.$route.query.pavilion_id}`);
            return base;
        },
        resolveJobAdRoute(jobAdId: string): string {
            return this.URLS.vfair.concat('/', this.$route.params.id).concat('/jobs/', jobAdId);
        },
    },
    mounted() {
        this.fetchCompaniesData().then(() => {
            this.fetchEvents();
        });
    },
});
